<template>
  <v-card>
    <v-list-item
        dark
        class="primary"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-alert
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">Application Alerts</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pa-2">
      <v-list three-line>
        <v-list-item
            v-for="item in alerts"
            :key="item.id"
            :class="getColor(item.type)"
            dark
            class="lighten-1 mb-1"
        >
          <v-list-item-avatar>
            <v-icon>{{ getIcon(item.type) }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="getTitle(item.type)"/>
            <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.created | formatFromNow }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon dark :to="'/applications/'+item.application">
              <v-icon>mdi-page-next</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-alert v-if="!alerts.length" class="text-center grey--text" dense>No alerts yet</v-alert>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import {errorNotification} from "@/components/utils";

export default {
  components: {},
  name: 'ApplicationAlerts',
  data() {
    return {
      alerts: []
    }
  },
  filters: {
    formatFromNow(date) {
      return moment(date).fromNow()
    }
  },
  methods: {
    fetchData() {
      this.$axios.get('/dashboard/applications/alerts/')
          .then((response) => {
            this.alerts = response.data
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    getTitle(type) {
      switch (type) {
        case 'confirmation':
          return 'Action Required!'
        case 'upload':
          return 'Documents Required!'
        case 'info':
          return 'Information'
        case 'warning':
          return 'Warning!'
      }
      return 'Information'
    },
    getIcon(type) {
      switch (type) {
        case 'confirmation':
          return 'mdi-check-decagram'
        case 'upload':
          return 'mdi-attachment'
        case 'info':
          return 'mdi-information'
        case 'warning':
          return 'mdi-alert'
      }
      return 'mdi-information'
    },
    getColor(type) {
      switch (type) {
        case 'confirmation':
          return 'success'
        case 'upload':
          return 'info'
        case 'info':
          return 'info'
        case 'warning':
          return 'warning'
      }
      return 'info'
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.v-list-item {
  border-radius: 3px !important;
}
</style>